module.exports = __webpack_public_path__ + "media/images/icon_faq-0e3ca9e6cd97a23439347ca00a52562b.png";